module.exports = __webpack_public_path__ + "static/media/YM80_7.3586e582.jpg";